import * as _ from 'lodash';
import { ColumnHandler } from '../types';
import { parseJson, parseDatetime, parseString } from '../converters';
import { TimezoneColumnType } from '../../monday-api/api';

export type TimezoneColumnValue = {
  text: string | null;
  timezone: string | null;
  changed_at: string | null;
};

const handler: ColumnHandler<TimezoneColumnType, TimezoneColumnValue> = {
  type: 'world_clock',

  default_value_field: 'text',

  supported_rules: [
    {
      operator: 'any_of',
      compare_value_ids: ['timezone'],
    },
    {
      operator: 'not_any_of',
      compare_value_ids: ['timezone'],
    },
  ],

  convertValueFromMondayToEngine: (columnValue) => {
    const text = parseString(columnValue.text);
    const value = parseJson(columnValue.value);
    const timezone = parseString(_.get(value, 'timezone'));
    const changedAt = parseDatetime(_.get(value, 'changed_at'));

    return {
      text,
      timezone,
      changed_at: changedAt,
    };
  },

  // TODO: properly support this
  getFormulaValue: (engineValue) => (engineValue.text === null ? '' : engineValue.text),
};

export default handler;
